<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      dark_mode: false,
      color_mode: "light",
      colors: ["#0077FF", "#cb4646", "#587991", "#464646", "#3a921d"],
      themes: [
        {
          key: "default",
          title: "Classic",
        },
        {
          key: "fresh",
          title: "Fresh",
        },
      ],
    };
  },
  mounted() {
    this.syncColorMode();
  },
  watch: {
    // тема могла смениться с другого устройства или при переключении синхронизации
    activeDarkMode() {
      this.syncColorMode();
    },
  },
  methods: {
    ...mapActions(["saveTheme"]),
    syncColorMode() {
      this.dark_mode = this.activeDarkMode;
      this.color_mode = this.dark_mode ? "dark" : "light";
    },
    // Сохранение (в базу или только на этом устройстве) решает store/appearance.
    // Класс dark-mode на body ставит MainLayout по user.theme.
    setColorMode(mode) {
      this.color_mode = mode;
      this.dark_mode = mode === "dark";
      this.saveTheme({ dark_mode: this.dark_mode });
    },
    changeColor(color) {
      this.saveTheme({ color });
    },
    changeTheme(theme) {
      this.saveTheme({ name: theme });
    },
  },
  computed: {
    ...mapGetters(["getUserData"]),
    activeTheme() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.name) {
          return this.getUserData.theme.name;
        } else return "default";
      } else return "default";
    },
    activeColor() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.color) {
          return this.getUserData.theme.color;
        } else return "#0077FF";
      } else return "#0077FF";
    },
    activeDarkMode() {
      if (this.getUserData.theme) {
        if (this.getUserData.theme.dark_mode) {
          return this.getUserData.theme.dark_mode;
        } else return false;
      } else return false;
    },
  },
};
</script>

<template>
  <div>
    <div class="themes_content themes_content_bottom_border">
      <h2>{{ $t("settings.theme.customization.colors") }}</h2>
      <ul class="themes_colors">
        <li
          v-for="color of colors"
          :key="color"
          :class="activeColor == color ? 'active' : ''"
          @click="changeColor(color)"
        >
          <div :style="'background-color: ' + color"></div>
        </li>
      </ul>
    </div>
    <div class="themes_content themes_content_bottom_border">
      <h2>{{ $t("settings.theme.customization.sidebar_style") }}</h2>
      <div
        class="profile__content__background-item"
        style="overflow-y: auto; height: 152px; width: 80%; margin-top: 5px"
      >
        <div
          v-for="theme of themes"
          :key="theme.key"
          @click="changeTheme(theme.key)"
          :class="
            activeTheme == theme.key
              ? 'active background-item__block'
              : 'background-item__block'
          "
        >
          <div style="background-color: #eee">
            <img
              :src="require(`@/assets/static/images/themes/${theme.key}.png`)"
              alt=""
            />
          </div>
          <span>{{ theme.title }}</span>
        </div>
      </div>
    </div>
    <div class="themes_content">
      <h2>{{ $t("settings.theme.customization.appearance") }}</h2>
      <div class="theme_appearance_options">
        <label class="theme_appearance_option">
          <input
            type="radio"
            name="color-mode"
            value="light"
            style="margin-right: 5px"
            v-model="color_mode"
            @change="setColorMode('light')"
          />
          <span
            class="theme_appearance_preview theme_appearance_preview--light"
          >
            <i></i><i></i><i></i>
          </span>
          <span>{{ $t("settings.theme.customization.light") }}</span>
        </label>
        <label class="theme_appearance_option">
          <input
            type="radio"
            name="color-mode"
            value="dark"
            style="margin-right: 5px"
            v-model="color_mode"
            @change="setColorMode('dark')"
          />
          <span class="theme_appearance_preview theme_appearance_preview--dark">
            <i></i><i></i><i></i>
          </span>
          <span>{{ $t("settings.theme.customization.dark") }}</span>
        </label>
      </div>
    </div>
  </div>
</template>
